import React, { useState } from 'react';

import PropTypes from 'prop-types';

import {
  STRING_SCREEN_APPLYING_TO,
  STRING_SCREEN_IN,
} from '@zr/jobseeker-public/apps/jobseeker-screens/labels';

import './ApplyingToHeader.less';

const DEFAULT_COMPANY_LOGO = '/img/candidate/default_company_logo.svg';

export function ApplyingToHeader({
  companyLogo, companyName, headerPriority, jobLocation, jobTitle, layout,
}) {
  const HTag = `h${headerPriority}`;
  const SubHTag = `h${headerPriority + 1}`;

  // prioritize company provided logo
  const [logo, setLogo] = useState(companyLogo || DEFAULT_COMPANY_LOGO);

  // linked img might be bad, if so use the default
  let handleBadImg = null;
  // this logic is to avoid any endless loops
  // https://stackoverflow.com/q/3984287
  if (logo !== DEFAULT_COMPANY_LOGO) {
    handleBadImg = () => {
      setLogo(DEFAULT_COMPANY_LOGO);
    };
  }

  return (
    <div className={`ApplyingToHeader ${layout}`}>
      <img className="company_logo" onError={handleBadImg} src={logo} alt={companyName} />
      <section>
        <HTag className="job_title_wrapper">
          <div className="applying_to">{`${STRING_SCREEN_APPLYING_TO} `}</div>
          <div className="job_title">{jobTitle}</div>
        </HTag>
        <SubHTag className="company_and_location">
          {`${companyName} ${STRING_SCREEN_IN} ${jobLocation}`}
        </SubHTag>
      </section>
    </div>
  );
}

ApplyingToHeader.propTypes = {
  companyLogo: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  headerPriority: PropTypes.oneOf([1, 2, 3, 4, 5]),
  layout: PropTypes.string,
  jobLocation: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
};

ApplyingToHeader.defaultProps = {
  companyLogo: DEFAULT_COMPANY_LOGO,
  headerPriority: 2,
  layout: '',
};

export default ApplyingToHeader;
